import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ab2dc7d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "check-box" };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "list" };
const _hoisted_4 = { key: 1 };
import MyOrderTab from '@/materials/molecules/MyOrderTab.vue';
import { myOpenOrderSubscriber, myClosedOrderSubscriber, useMyOrder } from '@/logics/myorder';
import { onMounted, onUnmounted, ref, inject, watch, computed } from 'vue';
import MyOrderOpenList from '@/components/organisms/main/trade/myorder/MyOrderOpenList.vue';
import MyOrderClosedList from '@/components/organisms/main/trade/myorder/MyOrderClosedList.vue';
import MyOrderOpenHeader from '@/components/organisms/main/trade/myorder/MyOrderOpenHeader.vue';
import MyOrderClosedHeader from '@/components/organisms/main/trade/myorder/MyOrderClosedHeader.vue';
import { useOrder } from '@/logics/order';
import Loading from '@/materials/molecules/Loading.vue';
import CancelConfirm from '@/components/organisms/modal/CancelConfirm.vue';
import { useStore } from '@/store/store';
import { useSettings } from '@/logics/settings';
import { useMessage } from '@/const/messages';
import Checkbox from '@/materials/atoms/CheckBox.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        pair: null,
        base: null,
        quote: null,
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const toast = inject('toast');
            const store = useStore();
            const { format, ORDERS_TITLES, CANCEL_MESSAGES, MY_ORDER_PAIRS_CHECK } = useMessage();
            const contents = [
                {
                    value: 'OPEN ORDERS',
                    groupName: 'TAB-MYORDER',
                },
                {
                    value: 'CLOSED ORDERS',
                    groupName: 'TAB-MYORDER',
                },
            ];
            const tab = ref('OPEN ORDERS');
            const onClickTab = (value) => {
                tab.value = value;
            };
            // 初期データ取得とPusherのsubscribeの用意
            const { getOpenOrder, getClosedOrder } = useMyOrder();
            const { putUserSettings } = useSettings();
            const { postCancel, isLoading } = useOrder();
            const isLimitedClosePair = store.state.userSettings.isLimitedClosePair ? store.state.symbol.pair : undefined;
            if (props.isAuth) {
                (([__temp, __restore] = _withAsyncContext(() => Promise.all([getOpenOrder(), getClosedOrder(isLimitedClosePair)]).catch(() => {
                    console.error('fetch error myorder');
                }))),
                    yield __temp,
                    __restore());
            }
            const { subscribe: openSubscribe, unsubscribe: openUnsubscribe } = myOpenOrderSubscriber((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.id);
            const { subscribe: closedSubscribe, unsubscribe: closedUnsubscribe } = myClosedOrderSubscriber((_b = props.userInfo) === null || _b === void 0 ? void 0 : _b.id);
            onMounted(() => {
                openSubscribe();
                closedSubscribe();
            });
            onUnmounted(() => {
                openUnsubscribe();
                closedUnsubscribe();
            });
            // モーダル関連
            const isShowModal = ref(false);
            const cancelingOrder = ref();
            const showModal = (order) => __awaiter(this, void 0, void 0, function* () {
                if (store.state.userSettings.isCancelLeave) {
                    yield onCancel(order.id, false);
                    return;
                }
                cancelingOrder.value = order;
                isShowModal.value = true;
            });
            const onClose = () => {
                isShowModal.value = false;
            };
            // キャンセル処理関連
            const onCancel = (id, isChecked) => __awaiter(this, void 0, void 0, function* () {
                yield postCancel(id, props.pair).catch((err) => {
                    const data = err.response.data;
                    const message = err.trace
                        ? format(CANCEL_MESSAGES.CANCEL_FAILED)
                        : `${data.message}\r\n errorCode: ${data.errorCode}`;
                    toast.error(message);
                });
                if (isChecked) {
                    // 非同期で更新
                    store.state.userSettings.isCancelLeave = isChecked;
                    putUserSettings({
                        isCancelLeave: isChecked,
                    });
                }
                const isLimitedOpenPair = store.state.userSettings.isLimitedOpenPair ? store.state.symbol.pair : undefined;
                yield getOpenOrder(isLimitedOpenPair).catch(() => {
                    console.error('fetch error open myorder');
                });
            });
            //各注文情報の全表示設定更新
            const isShowAllPairs = (value) => {
                if (tab.value === 'OPEN ORDERS') {
                    store.state.userSettings.isLimitedOpenPair = value;
                    putUserSettings({
                        isLimitedOpenPair: value,
                    });
                }
                else if (tab.value === 'CLOSED ORDERS') {
                    store.state.userSettings.isLimitedClosePair = value;
                    putUserSettings({
                        isLimitedClosePair: value,
                    });
                }
            };
            const openListPairs = computed(() => {
                return store.state.openList.filter((obj) => {
                    return (!store.state.userSettings.isLimitedOpenPair || obj.pair.toLowerCase() === store.getters.symbol.pair.toLowerCase());
                });
            });
            const isCloseLoading = ref(false);
            watch(() => store.state.userSettings.isLimitedClosePair, () => __awaiter(this, void 0, void 0, function* () {
                if (isCloseLoading.value) {
                    return;
                }
                isCloseLoading.value = true;
                const isLimitedClosePair = store.state.userSettings.isLimitedClosePair ? store.state.symbol.pair : undefined;
                yield getClosedOrder(isLimitedClosePair).catch(() => console.log('fetch error closed myorder.'));
                isCloseLoading.value = false;
            }));
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", null, [
                    (isShowModal.value)
                        ? (_openBlock(), _createBlock(CancelConfirm, {
                            key: 0,
                            order: cancelingOrder.value,
                            base: props.base,
                            quote: props.quote,
                            onCanceling: onCancel,
                            onClose: onClose
                        }, null, 8, ["order", "base", "quote"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass({ flex: props.isAuth })
                    }, [
                        _createVNode(MyOrderTab, {
                            contents: contents,
                            onClick: onClickTab,
                            labels: [_unref(format)(_unref(ORDERS_TITLES).OPEN_ORDERS), _unref(format)(_unref(ORDERS_TITLES).CLOSED_ORDERS)]
                        }, null, 8, ["labels"]),
                        _createElementVNode("div", _hoisted_1, [
                            _withDirectives(_createVNode(Checkbox, {
                                mode: "dark",
                                class: _normalizeClass(["box", { 'en-box': _unref(store).state.userSettings.language === 'English' }]),
                                "is-init-check": _unref(store).state.userSettings.isLimitedOpenPair,
                                id: "limited-open-pair",
                                label: String(_unref(format)(_unref(MY_ORDER_PAIRS_CHECK).FIELD)),
                                onChange: isShowAllPairs
                            }, null, 8, ["class", "is-init-check", "label"]), [
                                [_vShow, tab.value === 'OPEN ORDERS' && props.isAuth]
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass({ disabled: isCloseLoading.value })
                            }, null, 2),
                            _withDirectives(_createVNode(Checkbox, {
                                mode: "dark",
                                class: _normalizeClass(["box", { 'en-box': _unref(store).state.userSettings.language === 'English' }]),
                                "is-init-check": _unref(store).state.userSettings.isLimitedClosePair,
                                id: "limited-close-pair",
                                label: String(_unref(format)(_unref(MY_ORDER_PAIRS_CHECK).FIELD)),
                                onChange: isShowAllPairs
                            }, null, 8, ["class", "is-init-check", "label"]), [
                                [_vShow, tab.value === 'CLOSED ORDERS' && props.isAuth]
                            ])
                        ])
                    ], 2),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_2, [
                            (tab.value === 'OPEN ORDERS')
                                ? (_openBlock(), _createBlock(MyOrderOpenHeader, { key: 0 }))
                                : _createCommentVNode("", true),
                            (tab.value === 'CLOSED ORDERS')
                                ? (_openBlock(), _createBlock(MyOrderClosedHeader, { key: 1 }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_3, [
                                (_unref(isLoading))
                                    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                                    : _createCommentVNode("", true),
                                (!_unref(isLoading))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _withDirectives(_createVNode(MyOrderOpenList, {
                                            list: _unref(openListPairs),
                                            onShowModal: showModal
                                        }, null, 8, ["list"]), [
                                            [_vShow, tab.value === 'OPEN ORDERS']
                                        ]),
                                        _withDirectives(_createVNode(MyOrderClosedList, {
                                            list: _unref(store).state.closedList
                                        }, null, 8, ["list"]), [
                                            [_vShow, tab.value === 'CLOSED ORDERS']
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]));
            };
        });
    }
});
